// chat-modal.component.ts
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FEATURE_FLAGS } from 'src/app/constants/feature-flags';
import { AccountsService } from 'src/app/services/identity/accounts.service';
import { ChatBridgeService } from 'src/app/services/shared/chat-bridge.service';
import { PosthogService } from 'src/app/services/shared/posthog.service';
import { ChatFacadeService } from '../../services/chat-facade.service';
@Component({
    selector: 'app-chat-toggle',
    templateUrl: './chat-toggle.component.html',
    styleUrls: ['./chat-toggle.component.scss'],
})
export class ChatToggleComponent implements OnInit, OnDestroy {
    modalOpen: boolean = false;
    private destroy$ = new Subject<void>();
    showChatButton: boolean;
    readonly hasUnreadMessages$ = this.chatFacade.hasUnreadMessages$;
    constructor(
        private readonly accountsService: AccountsService,
        private chatBridgeService: ChatBridgeService,
        private readonly posthogService: PosthogService,
        private readonly chatFacade: ChatFacadeService,
    ) {}

    async ngOnInit() {
        await this.chatFacade.initializeChat();
        await this.chatFacade.loadMyConversations().toPromise();
        this.chatBridgeService.isChatModalOpen$.pipe(takeUntil(this.destroy$)).subscribe((isOpen) => {
            this.modalOpen = isOpen;
            if (!isOpen) {
                this.chatFacade.goBackToHistory();
            }

        });

        this.accountsService.onCurrentUserChanged.pipe(takeUntil(this.destroy$)).subscribe(() => {
            this.showChatButton = this.posthogService.isFeatureEnabled(FEATURE_FLAGS.PSCC_CONNECT_LAUNCH);
        });

        this.showChatButton = this.posthogService.isFeatureEnabled(FEATURE_FLAGS.PSCC_CONNECT_LAUNCH);
    }

    ngOnDestroy() {
            this.chatFacade.cleanup();
            this.destroy$.next();
            this.destroy$.complete();
        }

    toggleModal() {
        this.chatBridgeService.toggleModal();
    }
}
